import {
  type ConsultingProjectDraftFormData,
  type ConsultingProjectFormData,
  type DevelopmentProjectDraftFormData,
  type DevelopmentProjectFormData,
  type ProjectDraftFormData,
  type ProjectFormData,
  ProjectType
} from '../types/project';

const requiredProperties: Array<
  keyof ProjectFormData | keyof ProjectDraftFormData
> = [
  'confidentiality',
  'visibility',
  'title',
  'description',
  'projectLead',
  'team',
  'fields',
  'topics',
  'services',
  'creationPeriod'
];
const requiredDevelopmentProperties: Array<
  keyof DevelopmentProjectFormData | keyof DevelopmentProjectDraftFormData
> = ['tasks', 'technologies'];
const requiredConsultingProperties: Array<
  keyof ConsultingProjectFormData | keyof ConsultingProjectDraftFormData
> = ['formats', 'methods'];

/**
 * Returns whether the passed project has all mandatory properties or is a draft
 */
const isProjectDraft = (
  projectData: Partial<ProjectFormData | ProjectDraftFormData>,
  projectType: ProjectType
): projectData is ProjectDraftFormData => {
  const hasMissingProperty = <
    T extends keyof ProjectFormData | keyof ProjectDraftFormData
  >(
    property: T
  ): boolean => {
    const value = projectData[property];
    return value == null || (Array.isArray(value) && !value.length);
  };

  return (
    requiredProperties.some(hasMissingProperty) ||
    (projectType === ProjectType.DEVELOPMENT &&
      requiredDevelopmentProperties.some(hasMissingProperty)) ||
    (projectType === ProjectType.CONSULTING &&
      requiredConsultingProperties.some(hasMissingProperty))
  );
};

export default isProjectDraft;
